<template>
  <div class="ugc-item" v-if="data" @click="bindToDynamic(data)">
    <div class="user-info" @click.stop="bindToUser(data)">
      <div class="avatar-container">
        <img class="avatar" :src="data.base.user.u_img" alt="" />
      </div>
      <div class="user-info-center" v-if="data.base.user">
        <div class="nickname">{{ data.base.user.u_name }}</div>
        <div class="alias" v-if="data.base.user.label_data">{{
          data.base.user.label_data.alias
        }}</div>
      </div>
      <div
        class="focus"
        v-if="data.base.user && data.base.user.unify_id != uid"
      >
        <div v-if="data.base.user.is_follow" class="is-focus-btn">已关注</div>
        <div
          v-else
          class="not-focus-btn"
          @click.stop="bindFocus(data.base.user)"
          ><span class="iconfont icon-jiahao"></span>关注</div
        >
      </div>
    </div>
    <div class="ugc-title">{{ data.base.title }}</div>
    <div class="ugc-desc">{{ data.base.desc }}</div>
    <div v-if="data.base.image_list && data.base.image_list.length">
      <div class="image-container" v-if="data.base.cover_type == 1">
        <img class="image-item" :src="data.base.image_list[0].url" alt="" />
        <div class="image-num" v-if="data.base.image_list.length > 1">{{
          data.base.image_list.length
        }}</div>
      </div>
      <div class="image-container-four" v-else>
        <img
          class="image-item"
          v-for="(item, index) in 4"
          :key="index"
          :src="data.base.image_list[index].url"
          alt=""
        />
        <div class="image-num" v-if="data.base.image_list.length > 4">{{
          data.base.image_list.length
        }}</div>
      </div>
    </div>
    <!-- <div class="comment-info">
      <div class="comment-user-info">
        <img
          class="comment-avatar"
          src="https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg"
          alt=""
        />
        <div class="comment-nickname">九九小妹</div>
      </div>
      <div class="comment-say"
        >啥时候开始呢？在哪里报名呀，我跟一帮小伙伴都想参加。
        好久没有出来citywalk了，期待期待..</div
      >
    </div> -->
    <div class="ugc-bottom">
      <div class="tag-container">
        <div class="tag-list" v-if="data.detail.topic_data">
          <div
            class="tag-item"
            @click.stop="bindToTopic(item)"
            v-for="(item, index) in data.detail.topic_data"
            :key="index"
            >#{{ item.topic }}</div
          >
        </div>
      </div>
      <div class="icon-list">
        <div class="icon-item">
          <img
            class="icon comment-icon"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/e321585433d9159c48db08225714fb0a_wh=80_80.webp"
            alt=""
          />
          <span class="icon-num">{{
            (data.base.comment_info && data.base.comment_info.number) || 0
          }}</span>
        </div>
        <div class="icon-item">
          <img
            class="icon like-icon"
            v-if="data.base.like_info.is_like"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/91b42c60b7ba91e5c20df0a9f9652a5b_wh=80_80.webp"
            alt=""
          />
          <img
            class="icon like-icon"
            v-else
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/eadefbb1a1db6f65f433e4ec004ccba1_wh=80_80.webp"
            alt=""
          />
          <span class="icon-num">{{
            (data.base.like_info && data.base.like_info.number) || 0
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    uid() {
      let uid =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.uid) ||
        0
      return uid
    }
  },
  created() {},
  methods: {
    bindToDynamic(item) {
      let id = item.detail.id
      if (id) {
        this.$betterwe.jumpRoute(
          '/ugcDetails?tabType=weapp_group_unify&id=' + id
        )
      }
    },
    bindToUser(item) {
      let id = item.base?.user?.unify_id
      if (id) {
        this.$betterwe.jumpRoute('/userDetailsPage?id=' + id)
      }
    },
    bindToTopic(item) {
      let id = item.topic_id
      if (id) {
        this.$betterwe.jumpRoute('/ugcTopicUgcListPage?topicId=' + id)
      }
    },
    async bindFocus(user) {
      let params = {
        unify_id: user.unify_id,
        flag: 1
      }
      let res = await this.$http
        .postBaseApp('member/appCamp/optionFollow', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('关注成功')
          user.is_follow = 1
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ugc-item {
  position: relative;
  padding: 0px 20px 0px;
  margin-bottom: 32px;
  .user-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    .avatar-container {
      position: relative;
      width: 36px;
      height: 36px;
      margin-right: 10px;
      .avatar {
        overflow: hidden;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .user-info-center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 20px;
      .nickname {
        font-weight: bold;
        font-size: 14px;
        color: #050b27;
        line-height: 20px;
      }
      .alias {
        font-size: 12px;
        color: rgba(5, 11, 39, 0.5);
        line-height: 17px;
      }
    }
    .focus {
      .not-focus-btn {
        width: 72px;
        height: 28px;
        background: #ffffff;
        border-radius: 14px;
        border: 1px solid rgba(5, 11, 39, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 12px;
        color: #050b27;
        line-height: 17px;
        .iconfont {
          font-size: 14px;
          margin-right: 4px;
        }
      }
      .is-focus-btn {
        width: 72px;
        height: 28px;
        background: #f7f7f7;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: normal;
        font-size: 12px;
        color: rgba(5, 11, 39, 0.3);
        line-height: 17px;
      }
    }
  }
  .ugc-title {
    font-weight: bold;
    font-size: 16px;
    color: #050b27;
    line-height: 21px;
    margin-bottom: 6px;
  }
  .ugc-desc {
    font-size: 15px;
    color: #050b27;
    line-height: 19px;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .image-container {
    position: relative;
    width: 335px;
    height: 335px;
    margin-bottom: 12px;
    .image-item {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      overflow: hidden;
      object-fit: cover;
    }
    .image-num {
      position: absolute;
      right: 10px;
      bottom: 10px;
      font-family: DIN;
      font-weight: bold;
      font-size: 32px;
      color: #ffffff;
      line-height: 36px;
      text-align: left;
      font-style: italic;
    }
  }
  .image-container-four {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .image-item {
      border-radius: 6px;
      overflow: hidden;
      width: 165px;
      height: 165px;
      object-fit: cover;
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .image-item:nth-child(2n) {
      margin-right: 0px;
    }
    .image-num {
      position: absolute;
      right: 10px;
      bottom: 10px;
      font-family: DIN;
      font-weight: bold;
      font-size: 32px;
      color: #ffffff;
      line-height: 36px;
      text-align: left;
      font-style: italic;
    }
  }
  .comment-info {
    background: #f7f7f7;
    border-radius: 4px;
    padding: 8px 10px 9px;
    margin-bottom: 9px;
    .comment-user-info {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .comment-avatar {
        border-radius: 50%;
        overflow: hidden;
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      .comment-nickname {
        font-weight: bold;
        font-size: 11px;
        color: #050b27;
        line-height: 16px;
      }
    }
    .comment-say {
      font-size: 10px;
      color: #050b27;
      line-height: 16px;
    }
  }
  .ugc-bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .tag-container {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
    }
    .tag-list {
      display: inline-block;
      .tag-item {
        font-weight: bold;
        font-size: 15px;
        color: #4d58a1;
        line-height: 17px;
      }
    }
    .icon-list {
      display: flex;
      align-items: center;
      font-size: 10px;
      color: rgba(48, 48, 56, 0.5);
      line-height: 14px;
      .icon-item {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
          margin-right: 4px;
        }
        .comment-icon {
        }
        .icon-num {
          font-weight: 500;
          font-size: 12px;
        }
      }
      .icon-item:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
